import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Mock implementation for local testing without Supabase
const createMockSupabase = () => ({
    auth: {
        getSession: async () => ({ data: { session: null }, error: null }),
        onAuthStateChange: (callback) => {
            // Logic to trigger callback if needed for testing
            return { data: { subscription: { unsubscribe: () => { } } } };
        },
        signInWithPassword: async ({ email, password }) => {
            console.log('Using Mock Auth Login');
            return {
                data: {
                    user: { id: 'mock-user-id', email: email || 'demo@example.com' },
                    session: { access_token: 'mock-token' }
                },
                error: null
            };
        },
        signUp: async ({ email, password }) => {
            console.log('Using Mock Auth Signup');
            return {
                data: {
                    user: { id: 'mock-user-id', email: email || 'demo@example.com' },
                    session: null // Force OTP flow simulation if session is null
                },
                error: null
            };
        },
        signOut: async () => ({ error: null }),
        verifyOtp: async () => ({
            data: { user: { id: 'mock-user-id' }, session: { access_token: 'mock-token' } },
            error: null
        }),
        resend: async () => ({ error: null }),
        resetPasswordForEmail: async () => ({ error: null }),
    },
    from: (table) => ({
        select: () => ({
            eq: () => ({
                single: async () => ({
                    data: {
                        id: 'mock-user-id',
                        full_name: 'Demo User',
                        subscription_tier: 'Free',
                        pricing_region: 'Asia',
                        free_tier_expires_at: new Date(Date.now() + 60 * 24 * 60 * 60 * 1000).toISOString(),
                        is_verified: true
                    },
                    error: null
                })
            }),
            single: async () => ({ data: null, error: { code: 'PGRST116' } }) // simulate "not found"
        }),
        insert: (data) => ({
            select: () => ({
                single: async () => ({
                    data: { ...data[0], id: 'mock-user-id' },
                    error: null
                })
            })
        })
    })
});

// Use real client if keys provided, otherwise use mock
export const supabase = (supabaseUrl && supabaseUrl !== 'https://your-project.supabase.co' && !supabaseUrl.includes('your-project'))
    ? createClient(supabaseUrl, supabaseAnonKey)
    : createMockSupabase();
